export const OriginsCompanys = {
  falabella: ["HUB Bicci - CTT de BICCI (E-BIEX)", "falabella default"],
};
